import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import {
  PERSON_PREFILL_LIST_KEYS,
  PERSON_PREFILL_LIST_LABELS,
  listSectionSummary,
  type PersonPrefillListKey,
} from '@/lib/person-prefill'

type PersonPrefillSuggestionsProps = {
  enabled: boolean
  draft: Record<string, unknown> | null | undefined
  keep: Partial<Record<PersonPrefillListKey, boolean>>
  onKeepChange: (key: PersonPrefillListKey, checked: boolean) => void
  busy?: boolean
}

/** Opt-in checklist for draft list sections. Hidden when the flag or draft is absent. */
export function PersonPrefillSuggestions({
  enabled,
  draft,
  keep,
  onKeepChange,
  busy = false,
}: PersonPrefillSuggestionsProps) {
  if (!enabled || !draft) return null

  const sections = PERSON_PREFILL_LIST_KEYS.filter((key) => {
    const items = draft[key]
    return Array.isArray(items) && items.length > 0
  })

  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground" role="status">
        Empty fields show LinkedIn suggestions. Accept saves those empty fields only. Discard
        leaves your saved profile unchanged.
      </p>
      {sections.map((key) => {
        const items = draft[key] as unknown[]
        return (
          <div key={key} className="flex items-start gap-3">
            <Checkbox
              id={`person-prefill-${key}`}
              checked={keep[key] !== false}
              onCheckedChange={(checked) => onKeepChange(key, checked === true)}
              disabled={busy}
              className="mt-0.5"
            />
            <div className="min-w-0 space-y-1">
              <Label htmlFor={`person-prefill-${key}`}>{PERSON_PREFILL_LIST_LABELS[key]}</Label>
              <p className="text-sm text-muted-foreground">{listSectionSummary(key, items)}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
